module.exports = "<div class=\"row\"> <div class=\"col-md-3\"> <qms-management-navigation-menu> </qms-management-navigation-menu> </div> <div class=\"col\"> <router-outlet></router-outlet> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/components/management/management.component.html
// module id = 261
// module chunks = 0